import templateUrl from './parcelFind.html'

/**
 * Component for parcel finder.
 *
 * @example
 * <tmr-parcel-find
 *   items="$ctrl.antenna.$items"
 *   parcel="$ctrl.parcel"
 *   on-found="$ctrl.onParcelFound(parcel)"
 * ></tmr-parcel-find>
 *
 * @type {ngComponent}
 * @param {array<Item>} items
 * @param {Parcel} parcel
 * @param {function} on-found
 */
export const tmrParcelFind = {
  ngType: 'component',
  templateUrl,
  controller: 'tmrParcelFindController',
  bindings: {
    items: '<',
    parcel: '<',
    onFound: '&',
  },
}

/**
 * Controller of component {@link tmrParcelFind}.
 *
 * @type {ngController}
 */
export class tmrParcelFindController {
  static ngType = 'controller'

  $onInit() {
    this.finding = false
    this.prevItemsLength = 0
  }

  $doCheck() {
    // Items are only ever added, so checking length is enough.
    if (
      !this.parcel.id &&
      !this.finding &&
      this.items.length > this.prevItemsLength
    ) {
      this.finding = true
      this.parcel
        .$find(this.items)
        .then(parcel => this.success(parcel))
        .finally(() => this.done())
      this.prevItemsLength = this.items.length
    }
  }

  success(parcel) {
    if (parcel.id) {
      this.prevItemsLength = 0
      this.onFound({ parcel: parcel })
    }
  }

  done() {
    this.finding = false
  }
}
